// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ea0cf85","453":"eab04bde","732":"630ae3c9"}[chunkId] + ".chunk.js";
};